import {ContentStatusValue} from "/@src/models/content";
import {ContentStatus} from "/@src/models/api";
import {MediaType} from "/@src/models/media";

/**
 * 获取当天0点时间
 */
export function mapperContentStatusValue(status?:ContentStatus): ContentStatusValue {
  if(!status){
    return ContentStatusValue.ALL
  }
  let ret = ContentStatusValue.ALL
  switch (status.toLowerCase()) {
    case ContentStatus.PUBLISHED:
      ret = ContentStatusValue.PUBLISHED
      break
    case ContentStatus.DRAFT:
      ret = ContentStatusValue.DRAFT
      break
    case ContentStatus.DELETED:
      ret = ContentStatusValue.DELETED
      break
  }
  return ret
}

export function mapperContentStatus(status:ContentStatusValue): ContentStatus {
  let ret = ContentStatus.PUBLISHED
  switch (status) {
    case ContentStatusValue.PUBLISHED:
      ret = ContentStatus.PUBLISHED
      break
    case ContentStatusValue.DRAFT:
      ret = ContentStatus.DRAFT
      break
    case ContentStatusValue.DELETED:
      ret = ContentStatus.DELETED
      break
  }
  return ret
}


export const getFileTypeBySuffix = (extension:string):MediaType=>{
  let type = MediaType.UNKNOWN
  switch (extension.replace('.','').toLowerCase()) {
    case "pdf":
    case "doc":
    case "docx":
    case "xls":
    case "xlsx":
      type = MediaType.REPORT
      break
    case "jpg":
    case "jpeg":
    case "png":
      type = MediaType.PICTURE
      break
    case "mp4":
      type = MediaType.VIDEO
      break
    case "mp3":
      type = MediaType.AUDIO
      break
  }
  return type
}
